import React, { useState } from "react";

export type ContractLinkType = "flex" | "injection" | "offtake";

const contractPermalinkUrl = (type: ContractLinkType, id: number | string) =>
  `${window.location.origin}/contract/${type}/${id}`;

interface CopyContractLinkButtonProps {
  type: ContractLinkType;
  id: number | string;
  className?: string;
}

const CopyContractLinkButton: React.FC<CopyContractLinkButtonProps> = ({ type, id, className }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = () => {
    if (!navigator.clipboard) return;
    // Flip "Copied" only after the write resolves — a rejected write (denied
    // permission / unfocused document) must not show a false success.
    navigator.clipboard
      .writeText(contractPermalinkUrl(type, id))
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
      })
      .catch(() => {});
  };

  return (
    <button type="button" onClick={handleCopyLink} className={className}>
      {copied ? "Copied" : "Copy link"}
    </button>
  );
};

export default CopyContractLinkButton;
